import React, {FC} from "react";
import {useEditorLocation} from "../../../../editor/editor.hook";
import {OrderAddress} from "../../redux/types";
import {AddressWithNameForm} from "../../form/AddressWithNameForm";
import {OrderAddressDisplay} from "./OrderAddressDisplay";

interface EditableOrderAddressProps {
    editIdentifier: string;
    onSubmit: (orderAddress: OrderAddress) => Promise<any>;
    value?: OrderAddress;
    className?: string;
    isInvoiceAddress?: boolean
}

export const EditableOrderAddress: FC<EditableOrderAddressProps> = (props) => {

    const {mode, reference} = useEditorLocation();
    const showNameForm = mode === 'edit' && reference === props.editIdentifier;

    return showNameForm
        ? (
            <AddressWithNameForm
                isInvoiceAddress={props.isInvoiceAddress}
                initialValues={props.value}
                onSubmit={props.onSubmit}
                className={props.className}
            />
        )
        : (
            <OrderAddressDisplay
                editIdentifier={props.editIdentifier}
                isInvoice={props.isInvoiceAddress}
                className={props.className}
                value={props.value}
            />
        )

}